import { fetch } from '../request';
import type { IPageResponse, IPaginatedConfig, IResponse, RequestConfig } from '../interface';
import {
  type IGetIndustryInfo,
  type IGetCaseList,
  type IGetCaseItem,
  type IGetCaseInfo,
  type IIndustryApplication,
  type IProductHighlight,
  type IPageCard,
  type IGetTagsResponse,
  PAGE_CARD_TYPE,
} from '../interface/publicize';

// 获取行业详情
export const getIndustryDetail = (params: { id: string | number }) => {
  return fetch<IResponse<IIndustryApplication>>('/promotion_center/industry_applications/', {
    method: 'GET',
    params,
  });
};

// 获取全部行业页面信息
export const getIndustryInfo = () => {
  return fetch<IResponse<IGetIndustryInfo>>(
    '/promotion_center/industry_applications_second_page/',
    {
      method: 'GET',
    },
  );
};

// 获取标签名称
export const getAllAdminTags = () => {
  return fetch<IResponse<IGetTagsResponse>>('/tags/admin_tags/get_all_template_tags/', {
    method: 'GET',
    params: {
      group: 'template',
    },
  });
};

// 获取案例列表
export const getCaseList = (params: { page: number; page_size: number }) => {
  return fetch<IResponse<IGetCaseList>>('/promotion_center/enterprise_cases/list/', {
    method: 'GET',
    params,
  });
};

// 获取案例列表页面配置信息
export const getCaseInfo = () => {
  return fetch<IResponse<IGetCaseInfo>>('/promotion_center/enterprise_cases_second_page/', {
    method: 'GET',
  });
};

// 获取案例详情
export const getCaseDetail = (params: {
  id?: string | number;
  path_url?: string;
  is_copy?: boolean;
}) => {
  return fetch<IResponse<IGetCaseItem>>('/promotion_center/enterprise_cases/', {
    method: 'GET',
    params,
  });
};

// 产品亮点
// https://yapi.xmov.ai/project/542/interface/api/23989
// [GET](服务平台)列表
export function getProductHighlightsList() {
  return fetch<IResponse<IProductHighlight[]>>('/promotion_center/product_highlights/list/', {
    method: 'GET',
  });
}

// 行业应用
// https://yapi.xmov.ai/project/542/interface/api/24061
// [GET](服务平台)列表
export function getIndustryApplicationsList(params: IPaginatedConfig, config: RequestConfig = {}) {
  return fetch<IPageResponse<IIndustryApplication>>(
    '/promotion_center/industry_applications/list/',
    {
      method: 'GET',
      params,
      ...config,
    },
  );
}

// 获取个人优秀主页页面配置信息
export const getPromotionCenterPageCard = (params?: { type: PAGE_CARD_TYPE }) => {
  return fetch<IResponse<IPageCard[]>>('/promotion_center/page_card/', {
    method: 'GET',
    params,
  });
};

// [GET]获取数据
export interface IGetProductUpdateParams {
  page: number;
  page_size: number;
  many: number;
  o?: string;
  title__icontains?: string;
}

export interface IUpdate {
  link_url: string;
  id: number;
  title: string;
  cover_path: string;
  description: string;
  videos: string[];
  seo_title: string;
  seo_keywords: string;
  create_time: Date;
  update_time: Date;
  seo_description: string;
  iteration_time: Date;
  editor_id: number;
  cover_url: string;
  editor_name: string;
  is_delete: boolean;
}

export const getProductUpdate = (params?: IGetProductUpdateParams) => {
  return fetch<IPageResponse<IUpdate>>('/promotion_center/product_update/', {
    params,
  });
};
